import {BaseStore} from "../../../stem-core/state/Store.js";
import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient, type MerchantScopedRequest} from "../../connection/BlinkApiClient.js";
import type {StoreId} from "../../../stem-core/state/State";
import {BaseLogMessage} from "../misc/BaseLogMessage.js";
import {TaskStatus} from "../misc/GenericEnums.js";
import {globalStore} from "../../../stem-core/state/Store.js";
import {MerchantUser} from "./MerchantUserStore";

@globalStore
export class MerchantLogMessage extends BaseStore("MerchantLogMessage", {}, BaseLogMessage) {
    // @ts-ignore
    @field("MerchantUser") user: MerchantUser; // Type is changed from base
    @field("MerchantUser") assignedTo: MerchantUser;
    @field(TaskStatus) status: TaskStatus;
}

// EditMerchantLogMessageRequest (api/dashboard/views.py)
export interface EditMerchantLogMessageRequest extends MerchantScopedRequest {
    messageId: StoreId;
    assignedUserId?: StoreId;
    status?: TaskStatus;
}

export async function apiMerchantEditLogMessage(request: EditMerchantLogMessageRequest): Promise<any> {
    return apiClient.post("/merchant/edit_log_message", request);
}

// DeleteMerchantLogMessageRequest, the id on its own
export interface DeleteMerchantLogMessageRequest extends MerchantScopedRequest {
    messageId: StoreId;
}

export async function apiMerchantDeleteLogMessage(request: DeleteMerchantLogMessageRequest): Promise<any> {
    return apiClient.post("/merchant/delete_log_message", request);
}
